module.exports = __webpack_public_path__ + "assets/ca013ba2b28294dc0c2c4011e92fcbd9.mp3";